import React from 'react';

import { Box } from '@mui/material';

import Typography from '@/components/Typography';
import AIContent from '@/features/AIChat/AskGXDrawer/Messages/AIMessage/AIContent';
import MessageFooter from '@/features/AIChat/AskGXDrawer/Messages/MessageFooter';
import { useRateAnswer } from '@/features/AIChat/AskGXDrawer/Messages/RateAnswer/useRateAnswer';
import SymbolsPreviewSection from '@/features/AIChat/AskGXDrawer/Messages/SymbolsPreviewSection';
import type { AIMessage as AIMessageType } from '@/features/AIChat/types/chat';

const AIMessage = ({
  msg,
  isSending,
  isLastMessage,
  prompt,
  version
}: {
  msg: AIMessageType;
  isSending: boolean;
  isLastMessage: boolean;
  prompt: string;
  version: number;
}) => {
  const { handleRate, conversationId } = useRateAnswer();

  return (
    <Box
      sx={{
        padding: 0,
        maxWidth: '100%',
        marginBottom: '12px',
        minWidth: '100%'
      }}
    >
      <Typography
        component='div'
        sx={{ overflowWrap: 'break-word', hyphens: 'auto', fontSize: '14px' }}
      >
        <AIContent msg={msg} />
      </Typography>
      <SymbolsPreviewSection
        isVisible={!isSending || !isLastMessage}
        msg={msg}
      />
      <MessageFooter
        conversationId={conversationId}
        isLastMessage={isLastMessage}
        isSending={isSending}
        msg={msg}
        prompt={prompt}
        version={version}
        onRate={handleRate}
      />
    </Box>
  );
};

export default AIMessage;
